import React, { useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';
import PortalPageHeader from '../../common/PortalPageHeader';
import { AdminPageDetails, PageDetails } from '../config';
import { JobReport } from '../../JobReport';
import { JobProcessingBanner } from '../JobProcessingBanner';

export const InactiveAutoAssignmentReport = () => {
  const [id] = useState('inactiveAutoUnassignmentReport');
  const [title, setTitle] = useState('');
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  const loadPageTitle = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === id);
    setTitle(page.title);
  };

  const loadBreadcrumbs = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === id);
    setBreadcrumbs(page.breadcrumbs);
  };

  useEffect(() => {
    loadPageTitle();
    loadBreadcrumbs();
  }, []);

  return (
    <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`} style={{}}>
      <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
        <PortalPageHeader
          id={id}
          title={title}
          breadcrumbs={breadcrumbs}
          banner={<JobProcessingBanner />}
        />

        <Box id={`${id}__box_wrapper`}>
          <JobReport id={id} widgetName="Inactive Unassigment Jobs Report" />
        </Box>
      </Container>
    </div>
  );
};
